{
  "version": 1,
  "asset_id": "4551023e-41b5-4282-af73-5cacff4de79f",
  "project_id": "aee350b2-d827-4776-b2e7-5e8df2e4df2b",
  "url": "/__l5e/assets-v1/4551023e-41b5-4282-af73-5cacff4de79f/makai-logo.png",
  "r2_key": "a/v1/aee350b2-d827-4776-b2e7-5e8df2e4df2b/4551023e-41b5-4282-af73-5cacff4de79f/makai-logo.png",
  "original_filename": "makai-logo.png",
  "size": 1007307,
  "content_type": "image/png",
  "created_at": "2026-06-29T12:27:34Z"
}
